import { StringUtils } from './string.utils';

import $ from 'jquery/dist/jquery';
import {Router} from '@angular/router';

// @ObjectUtils class
export class ObjectUtils {

    public static jsonToSerialize (target: any, sp: string, type: string): string {
        let sSerial = '';
        $.each(target, function(k, v) {
            switch (type) {
                case 'k': // key만
                    sSerial += (k + sp);
                    break;
                case 'v': // value만
                    sSerial += (v + sp);
                    break;
                case 'kv': // key=value 로
                    sSerial += ((k + '=' + v) + sp);
                    break;
            }
        });
        return sSerial.substr(0, (sSerial.length - 1));
    }

    public static serializeToJson (target: any, k1: string, k2: string): any {
        const json = {};

        if (StringUtils.isNotEmpty(target)) {
            if (target.indexOf(k1) > -1) {
                target = target.split(k1);
                for (const e of target) {
                    if (e.indexOf(k2) > -1) {
                        const ae = e.split(k2);
                        json[ae[0]] = ae[1];
                    }
                }
            } else {
                if (target.indexOf(k2) > -1) {
                    const ae = target.split(k2);
                    json[ae[0]] = ae[1];
                }
            }
        }
        return json;
    }

    public static compareJson (oriJson: any, targetJson: any): any {
        // 비교 결과 JSON (다른 것 또는 oriJson에 없는 targetJson의 값이 들어감)
        const rJson = {};

        // oriJson과 값이 다른 targetJson값
        $.each(oriJson, function(k, v) {
            if (targetJson[k] !== undefined) {
                if (oriJson[k] !== targetJson[k]) {
                    rJson[k] = targetJson[k];
                }
            }
        });

        // targetJson에만 있는거
        $.each(targetJson, function(k, v) {
            if (oriJson[k] === undefined) {
                rJson[k] = v;
            }
        });

        return rJson;
    }

    public static compareArray (arr1: Array<any>, arr2: Array<any>): any {
        arr1 = arr1.sort();
        arr2 = arr2.sort();
        return (JSON.stringify(arr1) === JSON.stringify(arr2));
    }

    public static getDocumentInfo (key?: string): any {
        const doc = document;
        const loc = doc.location;
        const info = {
            href : loc.href,
            host : loc.host,
            hash : loc.hash,
            hostname : loc.hostname,
            pathname : loc.pathname,
            port : loc.port,
            origin : loc.origin,
            protocol : (loc.protocol.indexOf(':') > -1) ? loc.protocol.replace(':', '') : loc.protocol,
            querystring : (loc.search.indexOf('?') > -1) ? loc.search.replace('?', '') : loc.search,
            title : encodeURIComponent(doc.title)
        };

        info['querystringJSON'] = this.serializeToJson(info.querystring, '&', '=');

        if (key !== undefined) {
            return info[key];
        }
        return info;
    }

    private static stringifyReplacer(key: any, value?: any) : any {
        if (value === null) {
            return undefined;
        }
        return value;
    }

    public static objectToJson (obj: any, includenull?: boolean): string {
        if (includenull === true) {
            return JSON.stringify(obj);
        } else {
            return JSON.stringify(obj, this.stringifyReplacer);
        }
    }

    public static navigateToUrl (_route: Router, depth1: string, depth2: string, alias: string, options?: any) {
        const option = (options === '') ? '' : '/' + encodeURIComponent(JSON.stringify(options));
        const url = `/${depth1}/${(depth2 === '') ? alias : (alias === '') ? depth2 : depth2 + '/' + alias}${option}`;
        // console.log(`url : ${url}`);
        _route.navigate([url]);
        // _route.navigate([`/${depth1}/${depth2 }/${encodeURIComponent(JSON.stringify(optinos))}`]);
        return false;
    }

    public static changeUrl (depth1: string, depth2: string, depth3: string, options?: any) {
        const tmp = (options === '') ? '' : '' + encodeURIComponent(JSON.stringify(options));
        const url = `/${depth1}/${(depth2 === '') ? depth3 : (depth3 === '') ? depth2 : depth2 + '/' + depth3}/${tmp}`;
        //console.log(`url : ${url}`);
        const stateObj = { foo: 'bar' };
        history.pushState(null, null, url);
        return false;
    }

    public static jsonToQueryString(json) {
        return Object.keys(json).map((key: any) => {
            return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
        }).join(encodeURIComponent('&'));
    }

    public static jsonFormatter(val) {
        const JSONFormatter = require('simple-json-formatter');
        const formattedJson = JSONFormatter.format(JSON.stringify(val), '\t');
        return formattedJson;
    }

    public static isValidJson(json) {
        try {
            JSON.parse(json);
            return true;
        } catch (e) {
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/src/object.utils.ts